import React, { useEffect, useState } from 'react';
import { AlertTriangle, AlertCircle, Info, ShieldAlert, Pause, List } from 'lucide-react';
import { mockApi } from '../../lib/mockApi';
const iconMap: Record<string, any> = {
  critical: AlertTriangle,
  warning: AlertCircle,
  info: Info
};
export function LiveAlertTicker() {
  const [events, setEvents] = useState<any[]>([]);
  useEffect(() => {
    const loadData = async () => {
      const data = await mockApi.getAlerts();
      setEvents(data);
    };
    loadData();
    return mockApi.subscribe(loadData);
  }, []);
  if (events.length === 0) return null;
  return <div className="relative flex h-8 sm:h-9 w-full items-center overflow-hidden border-b border-border/60 bg-slate-950 text-slate-100 dark:bg-background dark:text-foreground" data-id="element-615">
      {/* Left Fixed Label */}
      <div className="flex items-center gap-2 px-3 h-full bg-slate-950 border-r border-slate-800 z-10 shrink-0 shadow-[4px_0_12px_rgba(0,0,0,0.5)]" data-id="element-616">
        <span className="size-2 rounded-full bg-red-500 animate-pulse" data-id="element-617" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-618">
          Live Intel
        </span>
      </div>

      {/* Scrolling Content */}
      <div className="flex flex-1 overflow-hidden" data-id="element-619">
        <div className="animate-marquee flex whitespace-nowrap hover:[animation-play-state:paused]" data-id="element-620">
          {/* Duplicate events to create seamless loop */}
          {[...events, ...events].map((event, i) => {
          const Icon = iconMap[event.severity] || Info;
          const colorClass = event.severity === 'critical' ? 'text-red-500' : event.severity === 'warning' ? 'text-amber-500' : 'text-primary';
          const dotClass = event.severity === 'critical' ? 'bg-red-500' : event.severity === 'warning' ? 'bg-amber-500' : 'bg-primary';
          return <div key={`${event.id}-${i}`} className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6" data-id="element-621">
                <Icon className={`size-3.5 sm:size-4 ${colorClass}`} data-id="element-622" />
                <span className="text-xs sm:text-sm font-medium tracking-wide" data-id="element-623">
                  {event.label}
                </span>
                <span className="font-mono text-[9px] sm:text-[10px] text-slate-400 dark:text-muted-foreground" data-id="element-624">
                  {event.time}
                </span>
                <div className={`size-1.5 rounded-full ml-2 sm:ml-4 ${dotClass}`} data-id="element-625" />
              </div>;
        })}
        </div>
      </div>

      {/* Right Fixed Controls */}
      <div className="flex items-center gap-3 px-3 h-full bg-slate-950 border-l border-slate-800 z-10 shrink-0 shadow-[-4px_0_12px_rgba(0,0,0,0.5)]" data-id="element-626">
        <button className="flex items-center gap-1.5 text-slate-400 hover:text-slate-100 transition-colors" data-id="element-627">
          <Pause className="size-3" data-id="element-628" />
          <span className="font-mono text-[9px] uppercase tracking-wider" data-id="element-629">
            Pause
          </span>
        </button>
        <div className="w-px h-3.5 bg-slate-800" data-id="element-630" />
        <button className="flex items-center gap-1.5 text-slate-400 hover:text-slate-100 transition-colors" data-id="element-631">
          <List className="size-3" data-id="element-632" />
          <span className="font-mono text-[9px] uppercase tracking-wider" data-id="element-633">
            All
          </span>
        </button>
      </div>
    </div>;
}